import { render, staticRenderFns } from "./Atalhos.vue?vue&type=template&id=58ec0382"
import script from "./Atalhos.vue?vue&type=script&lang=js"
export * from "./Atalhos.vue?vue&type=script&lang=js"
import style0 from "./Atalhos.vue?vue&type=style&index=0&id=58ec0382&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports